import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSelectionList, MatSelectionListChange, MatListModule } from '@angular/material/list';
import * as _ from 'lodash';
import { Client } from 'src/app/domain/client';
import { ELIMSService } from 'src/app/services/ELIMS.service';
import { UserService } from 'src/app/services/user.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-client-box',
    templateUrl: './client-selection-box.html',
    styleUrl: './client-selection-box.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatButtonModule, PreventDoubleClickDirective, MatIconModule, NgClass, MatListModule, MatCheckboxModule, MatDividerModule]
})
export class ClientSelectionBoxDialog implements OnInit {
    @ViewChild('allSelected') allSelected!: MatSelectionList;
    searchText: string = '';
    isHover?: number;
    alreadyAssignedList: Client[] = [];

    public AvailableClientList: Client[] = [];

    SelectedClientList: Client[] = [];

    constructor(
        private userService: ELIMSService,
        public dialogRef: MatDialogRef<ClientSelectionBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        // this.alreadyAssignedList = data.configuration.ClientList;
        if (data.alreadyAssignedList) {
            this.alreadyAssignedList = Object.assign([], data.alreadyAssignedList);
        }
    }

    ngOnInit() {

    }

    searchNewClient() {
        this.userService.getClientList(this.searchText).subscribe((x: Client[]) => {
            this.AvailableClientList = _.differenceBy(x, this.alreadyAssignedList, x => x.ElimsClientCode);
            this.AvailableClientList = _.sortBy(this.AvailableClientList, [
                function (item) { return item.Name; },
            ]);
        });
    }

    setSelectedClients(event: MatSelectionListChange) {
        if (event.options[0].selected) {
            this.SelectedClientList.push(...event.options.filter(e => e.selected).map(x => x.value));
            this.alreadyAssignedList.push(...event.options.filter(e => e.selected).map(x => x.value));
        } else {
            _.remove(this.SelectedClientList, x => x.ElimsClientCode === event.options[0].value.ElimsClientCode)
            _.remove(this.alreadyAssignedList, x => x.ElimsClientCode === event.options[0].value.ElimsClientCode)
        }
    }

    selectAll() {
        this.SelectedClientList = [];
        this.SelectedClientList.push(...this.AvailableClientList)
        _.pull(this.alreadyAssignedList, ..._.intersectionBy(this.alreadyAssignedList, this.AvailableClientList, x => x.ElimsClientCode))
        this.alreadyAssignedList = [...this.alreadyAssignedList, ...this.AvailableClientList]
        this.allSelected?.selectAll()
    }

    unselectAll() {
        this.SelectedClientList = [];
        this.allSelected?.deselectAll()
        this.alreadyAssignedList = _.differenceBy(this.alreadyAssignedList, this.AvailableClientList, x => x.ElimsClientCode)
        // this.allSelected.selectedOptions.
    }

    deleteClient(client: Client) {
        _.remove(this.alreadyAssignedList, x => x.ElimsClientCode === client.ElimsClientCode)
    }

    // CanAdd() {
    //     return this.SelectedClientList.length >= 1;
    // }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.alreadyAssignedList);
    }
}
